export type ListElementType<T extends string | number = number> = {
    id: T;
    name: string;
    description: string
};

export type SelectElementType<T = string> = {
    label: string;
    value: T;
};

export interface DesktopVersion {
    currentScreenWidth: number,
    isDesktopVersion: boolean,
}

export type  SelectElementSepctatorsType = {
    label: string;
    value: number;
    type: string;
    avatar: string | null;
}

export type SelectElementDescriptionType = {
    label: string;
    value: string;
    description: string;
};

export type SelectElementTypePicture = {
    label: string;
    value: string;
    avatar: string | null;
};
// Тех долг: подправить типизацию в base_select и TaskBaseSelect (привести все interfaces к одному)
export type BaseSelectUnion = SelectElementType | SelectElementTypePicture | SelectElementDescriptionType | SelectElementSepctatorsType

export type FieldValue =
    | number[]
    | string[]
    | string
    | number
    | boolean
    | undefined
    | null
    | UserFieldValue;

export interface SelectItem {
    id: number;
    label: string;
    avatar_url: string;
    active: boolean;
}

export interface SelectData {
    selectingData: SelectItem[];
}

export type TaskLogicHint = 'form' | 'task';

export const optionFieldExceptions = ['table', 'note', 'date', 'time', 'due_date', 'due_date_time'];

export const fieldOptionTypeGuard = (type: string): boolean => {
    return !optionFieldExceptions.includes(type)
}

export interface UserField {
    values: UserFieldValuesType[]
}

export type UserFieldValuesType = {
    field_id: number,
    value: UserFieldValue
}

export interface UserFieldValue {
    users: number[],
    departments: number[]
}

export type ImagesType = {
    id: number;
    file_path: string;
};

export interface DeepSearchQueryParams {
    is_closed?: number,
    sort_type?: number,
    max_items?: number,
    contains_string?: string,
    exclude_string?: string,
    author_id?: string,
    participant_user_ids?: string,
    participant_department_ids?: string,
    approver_user_ids?: string,
    approver_department_ids?: string,
    spectator_user_ids?: string,
    spectator_department_ids?: string,
    activity_start?: number | null,
    activity_end?: number | null,
    due_date_start?: number | null,
    due_date_end?: number | null,
    form_ids?: string,
    inbox?: number,
    with_values?: number,
    filter_by_fields?: string,
    sort_by_field?: number,
    read_status?: number,
    sort_ascending?: number,
    due_date_is_null?: number,
}


export interface DeepSearchParams {
    is_closed: number | null | 'ALL',
    sort_type: number,
    contains_string: string,
    exclude_string: string,
    author_id: string,
    participant_user_ids: string,
    participant_department_ids: string,
    approver_user_ids: string,
    approver_department_ids: string,
    spectator_user_ids: string,
    spectator_department_ids: string,
    activity_start: number | null,
    activity_end: number | null,
    form_ids: string | null,
    due_date_start: number | null,
    due_date_end: number | null,
    sort_ascending: number | null,
    due_date_is_null: number | null,
}

export type DetectedChangesMap = {
    addedItems: string[],
    removedItems: string[],
}

export enum AppTitles {
    Home = 'Rulse',
    Login = 'Login',
    Catalog = 'Catalog',
    CatalogList = 'CatalogList',
    FormList = 'FormList',
    Form = 'Form',
    FormConstructor = 'FormConstructor',
    TaskList = 'TaskList',
    TaskListIncoming = 'TaskListIncoming',
    Task = 'Task',
    TaskIncoming = 'TaskIncoming',
    Profile = 'Profile',
    Profiles = 'Profiles',
    Departments = 'Departments',
    Department = 'Department',
    BotsList = 'BotsList',
    Bot = 'Bot',
    Company = 'Company',
    Registry = 'Registry',

}
